<div class="w-full h-full flex flex-col gap-2 overflow-y-auto">
    <div class="w-full flex flex-col items-center justify-center gap-2">
        <h2 class="w-full oswald-font text-2xl">
            Review of Response, Management, and Support (RMS) Plan
        </h2>
    </div>

    <div class="h-full w-full overflow-y-auto flex flex-col items-start justify-start gap-4">
        <ol class="flex h-14 shrink-0 items-center w-full">            
            <li *ngFor="let step of stepsConfig" class="flex w-full items-center after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-100 after:border-4 after:inline-block">
                <button 
                    [attr.data-tooltip-target]="step.completionProperty" data-tooltip-placement="bottom"
                    class="flex items-center justify-center w-10 h-10 rounded-full shrink-0"
                    [ngClass]="{
                        'bg-nside-orange-400': currentStep === step.id,
                        'bg-orange-100': currentStep !== step.id && currentRmsRecordReview?.[step.completionProperty] === 1,
                        'bg-gray-100': currentStep !== step.id && currentRmsRecordReview?.[step.completionProperty] !== 1,
                        'cursor-not-allowed': step.nextStepDependency && currentRmsRecordReview?.[step.nextStepDependency] !== 1
                    }"
                    (click)="goToStep(step.id)"
                    [disabled]="step.nextStepDependency && currentRmsRecordReview?.[step.nextStepDependency] !== 1"
                >
                    <lucide-icon [img]="icons.FileUser" [ngClass]="{
                        'text-white': currentStep === step.id,
                        'text-nside-orange-400': currentStep !== step.id && currentRmsRecordReview?.[step.completionProperty] === 1,
                        'text-gray-text': currentStep !== step.id && currentRmsRecordReview?.[step.completionProperty] !== 1
                    }"></lucide-icon>
                </button>
                <div [id]="step.completionProperty" role="tooltip" class="absolute z-30 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                    {{ tooltips[step.id-1]}}
                    <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
            </li>
            <li class="flex items-center">
                <button 
                    [attr.data-tooltip-target]="finalStepConfig.completionProperty" data-tooltip-placement="bottom"
                    class="flex items-center justify-center w-10 h-10 rounded-full shrink-0"
                    [ngClass]="{
                        'bg-nside-orange-400': currentStep === finalStepConfig.id,
                        'bg-orange-100': currentStep !== finalStepConfig.id && currentRmsRecordReview?.[finalStepConfig.completionProperty] === 1,
                        'bg-gray-100': currentStep !== finalStepConfig.id && currentRmsRecordReview?.[finalStepConfig.completionProperty] !== 1,
                        'cursor-not-allowed': finalStepConfig.nextStepDependency && currentRmsRecordReview?.[finalStepConfig.nextStepDependency] !== 1
                    }"
                    (click)="goToStep(finalStepConfig.id)"
                    [disabled]="currentRmsRecordReview?.[finalStepConfig.nextStepDependency] !== 1"
                >
                    <lucide-icon [img]="icons.FileCheck" [ngClass]="{
                        'text-white': currentStep === finalStepConfig.id,
                        'text-nside-orange-400': currentStep !== finalStepConfig.id && currentRmsRecordReview?.[finalStepConfig.completionProperty] === 1,
                        'text-gray-text': currentStep !== finalStepConfig.id && currentRmsRecordReview?.[finalStepConfig.completionProperty] !== 1
                    }"></lucide-icon>
                </button>
                <div [id]="finalStepConfig.completionProperty" role="tooltip" class="absolute z-30 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                    {{ tooltips[finalStepConfig.id-1]}}
                    <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
            </li>
        </ol>
        <div class="w-full flex flex-col items-center justify-center overflow-y-auto gap-2">
            <reviewer-info
                *ngIf="this.currentStep===1 && this.currentRmsRecordReview"
                class="w-full h-full overflow-y-auto"
                [rmsRecordReviewData]="this.currentRmsRecordReview" 
                (onSaveSection1)="handleUpdateRoarAssignmentForm($event, 1)"
            ></reviewer-info>
            <progress-notes
                *ngIf="this.currentStep===2"
                class="w-full h-full overflow-y-auto"
                [rmsRecordReviewData]="this.currentRmsRecordReview" 
                (onSaveSection2)="handleUpdateRoarAssignmentForm($event, 2)"
            ></progress-notes>
            <rms-review-official-signature
                *ngIf="this.currentStep===3"
                class="w-full h-full overflow-y-auto"
                [rmsRecordReviewData]="this.currentRmsRecordReview" 
                (onSaveSection3)="handleUpdateRoarAssignmentForm($event, 3)"
            ></rms-review-official-signature>
            <rms-review-submission
                *ngIf="this.currentStep===4"
                class="w-full h-full overflow-y-auto"
                [rmsRecordReviewData]="this.currentRmsRecordReview" 
                (onSaveSection4)="handleUpdateRoarAssignmentForm($event, 4)"
            ></rms-review-submission>
        </div>
    </div>  
</div>

<popup-message 
    [type]="messageModal"
    [message]="popupMessage"
    (close)="resetMessageModal()"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>